// extracted by mini-css-extract-plugin
module.exports = {"section":"Accordion_section__3bqop","title":"Accordion_title__3jXkS","open":"Accordion_open__3KRhl","chevron":"Accordion_chevron__9KnbB","content":"Accordion_content__hyeeg"};